module.exports = __webpack_public_path__ + "static/img/success.30102617.png";